import React from 'react';
import { useTranslation } from 'react-i18next';

export function LegalContentsDisclosure(props: {
  sections: { id: string; title: string }[];
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <details className="legal-contents">
      <summary className="legal-contents__summary">{t('contents')}</summary>
      <ul className="legal-contents__list">
        {props.sections.map((section) => (
          <li key={section.id}>
            <a href={`#${section.id}`} className="legal-contents__link">
              {section.title}
            </a>
          </li>
        ))}
      </ul>
    </details>
  );
}
